import { colors } from "@material-ui/core";
import toast from "react-hot-toast";

import { makeRequest } from "@/util";

import { RedditIcon } from "@/components/icons/themes/logos";
import { DestinationConfigRow } from "@/destinations/configs/shared/ConfigPageRow";

export function OAuthModal() {
  return null;
}

export function OAuthRow({ existingConfig, destination }) {
  const settings = existingConfig.settings || {};
  const oauthConfigured = "oauthToken" in settings;

  const disableRow = !existingConfig.id;

  const onOpenConfigModal = () => {
    makeRequest("get_oauth_url", {
      integration_name: destination.slug,
      destination_id: existingConfig?.id,
    })
      .then((response) => {
        if (typeof response.data === "string" && response.data !== "") {
          window.location.href = response.data;
        } else {
          throw new Error("Malformed response from get_oauth_url");
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error(
          "Something went wrong. Unable to setup " + destination.name + ".",
        );
      });
  };

  const loginButton = (
    <div
      className="font-semi-bold inline-flex w-auto cursor-pointer items-center rounded border border-[#FF4500] px-2 py-1"
      onClick={onOpenConfigModal}
    >
      <RedditIcon
        className="position mr-2 fill-white"
        height="2em"
        style={{ top: -2 }}
      />
      {oauthConfigured ? "Reconnect" : "Login with Reddit"}
    </div>
  );

  return (
    <DestinationConfigRow
      name="Access Permission"
      disabled={disableRow}
      buttonComponent={loginButton}
      textColor={oauthConfigured ? "" : colors.red[600]}
      labelText={oauthConfigured ? "Connected" : "Not Connected"}
      onOpenConfigModal={onOpenConfigModal}
    />
  );
}
